// proxyConfig.js - Configuration simplifiée
export const getApiHeaders = () => {
  return {
    'code-ambassade': 'uuidARBC0A4',
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
};

export const getApiUrl = (endpoint) => {
  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://api-diplomatie.olasoft.net';
  return baseUrl + endpoint;
};